// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"az_ZBb","labelLinkItem":"az__Bb","commonCookieBtnStyles":"az_aCb","cookieButtonElement":"az_bCb","cookieStick":"az_cCb"};